const StaffActionTypes = {
	// Version : 0.0.2
	// Author : DINESH
	// MODFIED DATA : 07-08-2025

	/*****************  GET STAFF LIST START  *******************/
	GET_STAFF_LIST_START: 'get_staff_list_start',
	GET_STAFF_LIST_SUCCESS: 'get_staff_list_success',
	GET_STAFF_LIST_FAILURE: 'get_staff_list_failure',
	GET_STAFF_LIST_RESPONSE_RESET: 'get_staff_list_response_reset',
	GET_STAFF_LIST_RESPONSE_CHANGED: 'get_staff_list_response_changed',
	/*****************  GET STAFF LIST END  *******************/

	/*****************  UPDATE ISPUBLISH DETAILS START  *******************/
	UPDATE_ISPUBLISH_STATUS_START: 'update_isPublish_status_start',
	UPDATE_ISPUBLISH_STATUS_SUCCESS: 'update_isPublish_status_success',
	UPDATE_ISPUBLISH_STATUS_FAILURE: 'update_isPublish_status_failure',
	UPDATE_ISPUBLISH_STATUS_RESPONSE_RESET: 'update_isPublish_status_response_reset',
	UPDATE_ISPUBLISH_STATUS_RESPONSE_CHANGED: 'update_isPublish_status_response_changed',
	/*****************  UPDATE ISPUBLISH DETAILS END  *******************/

	/*****************  DELETE STAFF DETAILS START  *******************/
	DELETE_STAFF_DETAILS_START: 'delete_staff_details_start',
	DELETE_STAFF_DETAILS_SUCCESS: 'delete_staff_details_success',
	DELETE_STAFF_DETAILS_FAILURE: 'delete_staff_details_failure',
	DELETE_STAFF_DETAILS_RESPONSE_RESET: 'delete_staff_details_response_reset',
	DELETE_STAFF_DETAILS_RESPONSE_CHANGED: 'delete_staff_details_response_changed',
	/*****************  DELETE STAFF DETAILS END  *******************/

	/*****************  ADD STAFF DETAILS START  *******************/
	ADD_STAFF_DETAILS_START: 'add_staff_details_start',
	ADD_STAFF_DETAILS_SUCCESS: 'add_staff_details_success',
	ADD_STAFF_DETAILS_FAILURE: 'add_staff_details_failure',
	ADD_STAFF_DETAILS_RESPONSE_RESET: 'add_staff_details_response_reset',
	ADD_STAFF_DETAILS_RESPONSE_CHANGED: 'add_staff_details_response_changed',
	/*****************  ADD STAFF DETAILS END  *******************/

	/*****************  FETCH STAFF DETAILS START  *******************/
	FETCH_STAFF_DETAILS_START: 'fetch_staff_details_start',
	FETCH_STAFF_DETAILS_SUCCESS: 'fetch_staff_details_success',
	FETCH_STAFF_DETAILS_FAILURE: 'fetch_staff_details_failure',
	FETCH_STAFF_DETAILS_RESPONSE_RESET: 'fetch_staff_details_response_reset',
	FETCH_STAFF_DETAILS_RESPONSE_CHANGED: 'fetch_staff_details_response_changed',

	FETCH_STAFF_DETAILS_RESET_COMPONENT_START: 'fetch_staff_details_reset_component_start',
	/*****************  FETCH STAFF DETAILS END  *******************/

	/*****************  UPDATE STAFF DETAILS START  *******************/
	UPDATE_STAFF_DETAILS_START: 'update_staff_details_start',
	UPDATE_STAFF_DETAILS_SUCCESS: 'update_staff_details_success',
	UPDATE_STAFF_DETAILS_FAILURE: 'update_staff_details_failure',
	UPDATE_STAFF_DETAILS_RESPONSE_RESET: 'update_staff_details_response_reset',
	UPDATE_STAFF_DETAILS_RESPONSE_CHANGED: 'update_staff_details_response_changed',
	/*****************  UPDATE STAFF DETAILS END  *******************/

	/*****************  UPDATE PRINT RECEIPT STAFF DETAILS START  *******************/
	UPDATE_ISPRINT_STAFF_START: 'update_isprint_staff_start',
	UPDATE_ISPRINT_STAFF_SUCCESS: 'update_isprint_staff_success',
	UPDATE_ISPRINT_STAFF_FAILURE: 'update_isprint_staff_failure',
	UPDATE_ISPRINT_STAFF_RESPONSE_RESET: 'update_isprint_staff_response_reset',
	UPDATE_ISPRINT_STAFF_RESPONSE_CHANGED: 'update_isprint_staff_response_changed',
	/*****************  UPDATE PRINT RECEIPT STAFF DETAILS END  *******************/

	/*****************  GET ALL STAFF START  *******************/
	GET_ALL_STAFF_START: 'get_all_staff_start',
	GET_ALL_STAFF_SUCCESS: 'get_all_staff_success',
	GET_ALL_STAFF_FAILURE: 'get_all_staff_failure',
	GET_ALL_STAFF_RESPONSE_RESET: 'get_all_staff_response_reset',
	GET_ALL_STAFF_RESPONSE_CHANGED: 'get_all_staff_response_changed',
	/*****************  GET ALL STAFF END  *******************/
};
export default StaffActionTypes;
